import { createTheme } from '@mui/material'
import orgConfig, { defaultConfig } from '../config/orgConfig'
import baseTheme from '../styles/theme'

const { augmentColor } = createTheme().palette

export class ConfigUtils {
  static defaultKnowledgeHubUrl = defaultConfig.links.knowledgeHub

  static defaultTheme = defaultConfig.theme

  static defaultName = defaultConfig.name

  static getNameForOrganisation(organisationId: string): string {
    return orgConfig[organisationId]?.name || this.defaultName
  }

  static getKnowledgeHubLinkForOrganisation(organisationId: string): string {
    return (
      orgConfig[organisationId]?.links.knowledgeHub ||
      this.defaultKnowledgeHubUrl
    )
  }

  static getDeepLinkURIForOrganisation(
    organisationId: string,
  ): string | undefined {
    return orgConfig[organisationId]?.links.deepLinkURI
  }

  static getThemeForOrganisation(organisationId: string) {
    return orgConfig[organisationId]?.theme ?? this.defaultTheme
  }

  static createThemeForOrganisation(organisationId: string) {
    const orgPalette = this.getThemeForOrganisation(organisationId)?.palette
    return createTheme(baseTheme, {
      palette: {
        ...orgPalette,
        ...(orgPalette?.primary?.main
          ? {
              primary: augmentColor({
                color: { main: orgPalette.primary.main },
              }),
            }
          : {}),
      },
    })
  }
}
